<template>
  <p-dialog 
    :visible="visible" 
    :modal="true" 
    :closable="true" 
    :showHeader="false" 
    class="landing-page-modal"
    @hide="onCancel"
  >
    <div class="modal-content-wrapper">
        <button class="close-btn" @click="onCancel">
            <i class="pi pi-times"></i>
        </button>

        <div class="content-inner">
            <h2 class="modal-title">Create your free account today</h2>
            <p class="modal-subtitle">Use our charts for <strong style="color:black;">Free, Forever</strong>.</p>

            <div class="action-container">
            <p-button 
                label="Create an account" 
                class="p-button-lg create-account-btn" 
                @click="onCreateAccount" 
            />
            <p class="login-link">
              Already have an account?
              <a href="javascript:void(0)" @click="onLogin">Log in</a>
            </p>
            </div>
        </div>
        <div class="sso-divider">
              <span>or</span>
            </div>
            <div class="p-field p-d-flex p-jc-center p-mt-4">
             <div>
    <!-- easily customize the text using the 'label' prop -->
    <GoogleSsoBtn label="Sign up with Google" @click="loginWithGoogle" />
  </div>
            </div>
    </div>
  </p-dialog>
</template>

<script>
import { mapMutations } from 'vuex'
import config from '../../../config.js'
import GoogleSsoBtn from '../../googleSsoBtn.vue'
import { getStoredGclid } from '../../../utils/gclid'

export default {
  name: 'LandingPageModal',
  
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
   components:{
GoogleSsoBtn
  },
  methods: {
    ...mapMutations(['SET_LANDING_PAGE_MODAL', 'SET_AUTH_MODAL', 'SET_LOGIN_MODAL']),
    onCancel() {
      this.SET_LANDING_PAGE_MODAL(false)
    },
    onCreateAccount() {
      this.SET_LANDING_PAGE_MODAL(false)
      this.SET_AUTH_MODAL(true)
    },
    onLogin() {
      this.SET_LANDING_PAGE_MODAL(false)
      this.SET_LOGIN_MODAL(true)
    },
    loginWithGoogle(){
      const base = config.USER_API
      let url = `${base}auth/google`
      const gclid = getStoredGclid()
      if (gclid) {
        url += `?gclid=${encodeURIComponent(gclid)}`
      }

      // 1. Define popup size and position
  const width = 500;
  const height = 600;
  const left = (window.screen.width / 2) - (width / 2);
  const top = (window.screen.height / 2) - (height / 2);
  // 2. Open the popup
  const popup = window.open(
    url,
    'GoogleLogin',
    `width=${width},height=${height},left=${left},top=${top},status=no,location=no,menubar=no`
  );

if (!popup || popup.closed || typeof popup.closed === 'undefined') {
  // 1. Show an error to the user
  this.loginError = 'Popup blocked! Please allow popups to sign in with Google.';
}
  // 3. Listen for the token from the popup
  const handleMessage = (event) => {
    // Security check: Ensure message comes from your own domain
    if (event.origin !== window.location.origin) return;
    if (event.data.type === 'GOOGLE_AUTH_SUCCESS') {
      const { token, isNewUser } = event.data;
      
      // Save token and handle redirect
      localStorage.setItem('state', token);
      
      if (isNewUser === 'true') {
        this.$router.push({ name: 'products' });
      } else {
        location.reload(); // Refresh to log the user in
      }
      // Clean up
      window.removeEventListener('message', handleMessage);
    }
  };
  window.addEventListener('message', handleMessage);

    }
  }
}
</script>

<style scoped>
:deep(.p-dialog.landing-page-modal) {
  border-radius: 24px;
  overflow: hidden;
  width: 460px;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255,255,255,0.2);
}

:deep(.p-dialog-content) {
  padding: 0 !important;
  background: transparent !important;
}

/* Background & layout */
.modal-content-wrapper {
  position: relative;
  padding: 3.2rem 2.8rem 2.6rem;
  text-align: center;
  background: linear-gradient(145deg, #ffffff 0%, #f7f9fc 100%);
  animation: modalEnter 0.35s ease-out;
}

.content-inner {
  max-width: 360px;
  margin: 0 auto;
}

/* Close button */
.close-btn {
  position: absolute;
  top: 1.2rem;
  right: 1.2rem;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: none;
  background: rgba(0,0,0,0.04);
  color: #777;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background: rgba(0,0,0,0.08);
  color: #111;
}

/* Title */
.modal-title {
  font-size: 2rem;
  font-weight: 800;
  margin-bottom: 0.9rem;
  line-height: 1.2;
  letter-spacing: -0.5px;
  color: #111;
}

/* Subtitle */
.modal-subtitle {
  font-size: 1.05rem;
  color: #5a5a5a;
  margin-bottom: 2.4rem;
  line-height: 1.5;
}

/* Button container spacing */
.action-container {
  margin-top: 0.5rem;
}

/* CTA button */
.create-account-btn {
  width: 100%;
  padding: 1rem 0 !important;
  border-radius: 16px !important;
  font-weight: 700 !important;
  font-size: 1.1rem !important;
  background: linear-gradient(135deg, #db2828, #ff4d4d) !important;
  border: none !important;
  box-shadow: 0 12px 28px rgba(219, 40, 40, 0.4);
  transition: all 0.25s ease !important;
}

.create-account-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 34px rgba(219, 40, 40, 0.5);
}

.create-account-btn:active {
  transform: translateY(0);
  box-shadow: 0 8px 18px rgba(219, 40, 40, 0.35);
}

/* Animation */
@keyframes modalEnter {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Backdrop polish */
:deep(.p-dialog-mask) {
  backdrop-filter: blur(5px);
  background: rgba(0, 0, 0, 0.55) !important;
}


.login-link {
  margin-top: 16px;
  font-size: 14px;
  color: #666;
}

.login-link a {
  color: #2563eb;
  text-decoration: none;
  font-weight: 600;
}

.login-link a:hover {
  text-decoration: underline;
}
</style>
